import React from "react";
import classNames from "classnames";

const Actions = ({ reset, submit, className }) => (
  <div className={classNames("section__wrapper--actions", className)}>
    <div className="section__wrapper--actions__reset">{reset}</div>
    <div className="section__wrapper--actions__submit">{submit}</div>
  </div>
);

export default Actions;
